import { createBrowserRouter } from 'react-router-dom'

import { AppLayout } from '@/components/layout/app-layout'

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: '/',
        lazy: async () => {
          const { GamePage } = await import('@/pages/game-page')
          return { Component: GamePage }
        },
      },
      {
        path: '/stats',
        lazy: async () => {
          const { StatsPage } = await import('@/pages/stats-page')
          return { Component: StatsPage }
        },
      },
      {
        path: '/about',
        lazy: async () => {
          const { AboutPage } = await import('@/pages/about-page')
          return { Component: AboutPage }
        },
      },
      {
        path: '*',
        lazy: async () => {
          const { NotFoundPage } = await import('@/pages/not-found-page')
          return { Component: NotFoundPage }
        },
      },
    ],
  },
])
